document.addEventListener(
  'click',
  function (e) {
    if (!e.target.matches('.js-scroll-to')) {
      return;
    }

    e.preventDefault();

    const scrollToSelector = e.target.dataset.scrollTo;

    if (!scrollToSelector) {
      return;
    }

    const scrollToEl = document.querySelector(scrollToSelector);

    if (!scrollToEl) {
      return;
    }

    scrollToPosition(scrollToEl.offsetTop);

    if (e.target.dataset.scrollFocus !== undefined && e.target.dataset.scrollFocus.length !== 0) {
      setTimeout(() => {
        let focusEl = document.querySelector(e.target.dataset.scrollFocus);
        if (focusEl) {
          focusEl.focus();
        }
      }, 800);
    }
  },
  false,
);

export default function scrollToPosition(position) {
  let anchorNav = document.querySelector('.js-anchor-links__nav');

  if (!anchorNav) {
    anchorNav = 0;
  } else {
    anchorNav = anchorNav.offsetHeight;
  }

  window.scrollTo({
    top: position - 50 - anchorNav, // header offset
    behavior: 'smooth',
  });
}
